// Centralized configuration for API endpoints and settings

// API Configuration
const defaultBaseUrl = process.env.NODE_ENV === 'production' 
  ? 'https://api.akrosapp.com' 
  : 'http://localhost:3000';

const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_URL || defaultBaseUrl,
  adminBaseUrl: (process.env.REACT_APP_API_URL || defaultBaseUrl) + '/admin',
  apiBaseUrl: (process.env.REACT_APP_API_URL || defaultBaseUrl) + '/api',
  timeout: 30000, // 30 seconds
};

// Endpoints
export const API_ENDPOINTS = {
  // Auth
  adminLogin: '/admin/login',
  
  // Merchants
  merchants: '/merchants',
  
  // Shops
  shops: '/shops',
  shopDetail: (id) => `/shops/${id}`,
  shopImages: (shopId) => `/shop-images/${shopId}`,
  uploadShopImage: (shopId) => `/shop-images/upload/${shopId}`,
  deleteShopImage: (imageId) => `/shop-images/${imageId}`,
  
  // Shop Hours
  shopHours: (shopId) => `/shop-hours/${shopId}`,
  createShopHours: '/shop-hours',
  updateShopHours: (shopHoursId) => `/shop-hours/${shopHoursId}`,
  
  // Shop Offers
  shopOffers: (shopId) => `/shop-offers/${shopId}`,
  createShopOffer: (shopId) => `/shop-offers/create/${shopId}`,
  deleteShopOffer: (offerId) => `/shop-offers/${offerId}`,

  // Category Types
  categoryTypes: '/category-types',
  
  // Bookings
  bookings: '/bookings',
  bookingDetail: (id) => `/bookings/${id}`,
  
  // Parking
  parking: '/parking',
  parkingDetail: (id) => `/parking/${id}`,

  // Logs
  logsStats: '/logs/stats',
  activityLogs: '/logs/activity',
  errorLogs: '/logs/errors',
  purgeLogs: '/logs/purge',
};

// Helper to get full API URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.adminBaseUrl}${endpoint}`;
};

export const getPublicApiUrl = (endpoint) => {
    return `${API_CONFIG.apiBaseUrl}${endpoint}`;
};

// Token management utilities
export const tokenManager = {
  getToken: () => localStorage.getItem('adminToken'),
  setToken: (token) => localStorage.setItem('adminToken', token),
  removeToken: () => localStorage.removeItem('adminToken'),
  getAuthHeader: () => {
    const token = tokenManager.getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  },
};

export default API_CONFIG;

